import type { FC } from 'react';

import LoginForm from '@/features/auth/components/LoginForm';
import TwoFactorForm from '@/features/auth/components/TwoFactorForm';
import { useLoginPage } from '@/features/auth/hooks/useLoginPage.hook';

const LoginPage: FC = () => {
  const {
    step,
    email,
    password,
    code,
    codeError,
    errors,
    submitError,
    isSubmitting,
    onChangeEmail,
    onChangePassword,
    onChangeCode,
    onSubmit,
    onSubmitCode,
    onBackToPassword,
  } = useLoginPage();

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col items-center gap-2 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-500 text-2xl font-extrabold text-white shadow-lg">
          S
        </div>
        <h1 className="text-2xl font-extrabold text-[var(--color-ink)]">Shoutt Admin</h1>
        <p className="text-sm text-[var(--color-ink-muted)]">
          {step === 'twoFactor' ? 'Two-step verification' : 'Secure administrator access'}
        </p>
      </header>
      {step === 'twoFactor' ? (
        <TwoFactorForm
          email={email}
          code={code}
          codeError={codeError}
          submitError={submitError}
          isSubmitting={isSubmitting}
          onChangeCode={onChangeCode}
          onSubmit={onSubmitCode}
          onBack={onBackToPassword}
        />
      ) : (
        <LoginForm
          email={email}
          password={password}
          errors={errors}
          submitError={submitError}
          isSubmitting={isSubmitting}
          onChangeEmail={onChangeEmail}
          onChangePassword={onChangePassword}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};

export default LoginPage;
